import httpClient from "../httpClient";
import { API_DEPARTMENT_ENTITIES_LIST } from "../config";

const departmentEntitiesList = {
  get: (id) => httpClient.get(API_DEPARTMENT_ENTITIES_LIST+'/'+id),
};

export default departmentEntitiesList;
